import { useMutation, useQuery, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { getPerson, putContact } from "../../../queries/contacts";

export const PERSON_QUERY_KEY = "person" as const;
export function usePerson(id: number | string) {
  const headers = useNetworkHeaders();
  const personQuery = useQuery([PERSON_QUERY_KEY, id], () => getPerson(headers)(+id), {
    enabled: !!id,
  });
  return personQuery;
}

export function useUpdatePerson(id: number | string) {
  const headers = useNetworkHeaders();
  const queryCache = useQueryCache();
  const [updateContact, { isLoading }] = useMutation(putContact(headers, `${id}`), {
    throwOnError: true,
    onSuccess: () => {
      queryCache.invalidateQueries([PERSON_QUERY_KEY, id]);
    },
  });
  return { updateContact, isLoading };
}
